import React, { useContext, useEffect, useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RegisterSidebar from "../../component/RegisterSidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import LanguageSelect from "../../component/LanguageSelect";
import authLogo from "../../assets/images/auth-logo.svg";
import { AuthUserContext } from "../../context/context";
import { useTranslation } from "react-i18next";
import PhoneInputCode from "../../component/PhoneInput";
import Spinner from "react-bootstrap/Spinner";
import { GrFormNextLink, GrFormPreviousLink } from "react-icons/gr";
import phoneOtpWithGoogle from "../../services/auth/phoneOtpGoogle";
import { toast } from "react-toastify";
const PhoneWithGoogle = ({
  setEventTriggered,
  hideSidebar,
  isModal,
  setUserSignedUp,
  setGooglePhoneNoVerification,
  setLogin,
  handleClose,
  setIsModalShowChangePhoneNo
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const location = useLocation();
  const [validated, setValidated] = useState(false);
  const userId = location.state?.userId;
  console.log("userId", userId);

  const navigate = useNavigate();
  const {
    currentLocalization,
    setUser,
    linkCopy,
    topUpLink,
    setTopUpLink,
    setLinkCopy,
    setToastId,
    toastId,
    outSideUserPhoneNo,
    googleUserId,
    setGooglePhoneNo,
    setOutSideUserPhoneNo
  } = useContext(AuthUserContext);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!phoneNumber) {
        setValidated(true);
        return;
      }
      let lang;
      if (currentLocalization.startsWith("en-")) {
        lang = "en";
      } else {
        lang = currentLocalization;
      }
      const user_id = googleUserId ? googleUserId : userId;
      if (user_id) {
        setLoading(true)
        const object = {
          userId: user_id,
          phone_no: phoneNumber,
          lang:lang
        };
        const response = await phoneOtpWithGoogle(object);
        const id = toast.success(response.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        
        if (isModal) {
          setGooglePhoneNoVerification(false);
          setLogin(false)
          setUserSignedUp(true);
          setGooglePhoneNo(phoneNumber)
          setIsModalShowChangePhoneNo(false);
          setOutSideUserPhoneNo(response?.data?.phone_no)
        } else {
          navigate("/otp-verification", {
            state: { phone_no: phoneNumber, userId: response?.data?._id  },
          });
        }
        setToastId(id);
      } else {
        const id = toast.error(t("toastsMessage.part2"), {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      }
    } catch (err) {
      if (err.response?.status == 400) {
        const id = toast.error(err.response?.data?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      } else if (err.response?.status == 404) {
        const id = toast.error(err.response?.data?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      } else {
        const id = toast.error(err?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !loading) {
      if (toastId && typeof setEventTriggered === "function") {
        setEventTriggered(true);
      }
      event.preventDefault();
      handleSubmit(event);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container fluid className={isModal ? "" : "main-login-image"}>
      <Row className={isModal ? "" : "row-login d-flex justify-content-center"}>
        {!isModal && !hideSidebar && (
          <Col
            xs={11}
            md={6}
            className="loginImage p-0 d-flex justify-content-center align-items-center"
          >
            <RegisterSidebar />
          </Col>
        )}
        <Col
          xs={12}
          md={isModal ? 12 : 6}
          className={
            isModal ? "text-start login-side-modal" : "text-start login-side"
          }
        >
          <Row
            className={`d-flex justify-content-center align-items-center pt-${
              !isModal ? 5 : 0
            }`}
          >
            <Col
              md={9}
              className={`pt-0 p-md-0 p-4 d-flex align-items-center justify-content-between ${
                currentLocalization == "ar" && "flex-row-reverse"
              }`}
            >
              {!isModal && (
                <>
                  <Link
                    to="/"
                    onClick={() => {
                      setLinkCopy("");
                      setTopUpLink("");
                    }}
                  >
                    <img src={authLogo} alt="" />
                  </Link>
                  <LanguageSelect />
                </>
              )}
            </Col>
          </Row>
          <Row className="d-flex justify-content-center align-items-center pt-5 pb-5 large-screen">
            <Col md={isModal ? 11 : 9} className="pt-0 p-md-0 p-4">
              <div
                style={{ marginTop: "15px" }}
                className={`p-0 ${
                  currentLocalization == "ar" ? "text-end" : "text-start"
                }`}
              >
                <h2
                  className="login-welcome"
                  style={{ display: isModal ? "none" : "block" }}
                >
                  {t("signUp.part17")}
                </h2>

                <Form
                  onSubmit={handleSubmit}
                  method="post"
                  onKeyDown={handleKeyDown}
                  className={!isModal && "mt-4"}
                >
                  <PhoneInputCode
                    className={
                      currentLocalization == "ar"
                        ? "login-input-right"
                        : "login-input-left"
                    }
                    labelClassName="label"
                    labelText={t("signUp.part5")}
                    setPhoneNumber={setPhoneNumber}
                    phoneNumber={phoneNumber}
                  />
                  <div
                    className={
                      currentLocalization == "ar"
                        ? "text-end mt-2"
                        : "text-start mt-2"
                    }
                  >
                    {validated && !phoneNumber && (
                      <span className="text-danger">
                        {t("validation.phoneRequired")}
                      </span>
                    )}
                  </div>
                  <Row style={{ marginTop: "30px" }}>
                    <Col>
                      <div className="d-grid gap-2 ">
                        <button
                          className={
                            loading
                              ? "btn-login-main-disabled"
                              : "btn-login-main"
                          }
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              {currentLocalization == "ar" ? (
                                <>
                                  <span className="me-2">
                                    ... {t("login.part16")}
                                  </span>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                </>
                              ) : (
                                <>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  <span className="ms-2">
                                    {t("login.part16")} ...
                                  </span>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {currentLocalization == "ar" ? (
                                <>
                                  <GrFormPreviousLink
                                    size={27}
                                    className="me-1"
                                  />
                                  {t("signUp.part10")}
                                </>
                              ) : (
                                <>
                                  {t("signUp.part10")}
                                  <GrFormNextLink size={27} className="ms-1" />
                                </>
                              )}
                            </>
                          )}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default PhoneWithGoogle;
